import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Qué es el tratamiento de TMS de cinco días?",
    answer:
      "SAINT® es un protocolo de TMS acelerada que se administra durante cinco días consecutivos, con diez sesiones por día, para un total de 50 sesiones. Está autorizado por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
  },
  {
    question: "¿Es seguro recibir 50 sesiones en cinco días?",
    answer:
      "SAINT® se administra según el protocolo autorizado por la FDA. Como con cualquier tratamiento, existen consideraciones que el equipo clínico analiza durante la evaluación. La elegibilidad se confirma mediante una evaluación psiquiátrica.",
  },
];

export const esFiveDay = makeEsArticle({
  slug: "5-day-tms-treatment",
  title: "Tratamiento de TMS de cinco días (SAINT®)",
  description:
    "SAINT® es un protocolo de TMS acelerada administrado durante cinco días, con diez sesiones por día. Autorizado por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
  h1: "Tratamiento de TMS de cinco días",
  breadcrumbLabel: "TMS de cinco días",
  shortAnswer:
    "SAINT® es un protocolo de TMS acelerada que se administra durante cinco días consecutivos, con diez sesiones por día, para un total de 50 sesiones. Está autorizado por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. La TMS convencional, en comparación, suele durar seis semanas. La elegibilidad se confirma mediante una evaluación psiquiátrica.",
  keyTakeaways: [
    "SAINT® se administra durante cinco días consecutivos.",
    "Diez sesiones por día, 50 en total.",
    "Está autorizado por la FDA para el trastorno depresivo mayor en adultos.",
    "Está indicado para adultos que no han mejorado con antidepresivos.",
    "La TMS convencional suele durar seis semanas.",
  ],
  sections: [
    {
      heading: "El protocolo de cinco días",
      paragraphs: [
        "SAINT® administra 50 sesiones de estimulación theta burst durante cinco días consecutivos, con diez sesiones por día. Antes de iniciar el tratamiento, se realiza una resonancia magnética funcional (fMRI) para orientar la estimulación al circuito de cada persona.",
      ],
    },
    {
      heading: "SAINT® frente a la TMS convencional",
      paragraphs: [
        "La TMS convencional suele durar seis semanas, con sesiones diarias de lunes a viernes. SAINT® comprime el tratamiento en cinco días mediante un calendario acelerado, orientación por fMRI y estimulación theta burst.",
      ],
    },
    {
      heading: "Para quién es",
      paragraphs: [
        "SAINT® está autorizado por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. No está indicado para ansiedad, trastorno bipolar, TEPT u otras condiciones. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
